import { render } from "./IniziaRilevazione.vue?vue&type=template&id=f616251a&scoped=true"
import script from "./IniziaRilevazione.vue?vue&type=script&lang=js"
export * from "./IniziaRilevazione.vue?vue&type=script&lang=js"

import "./IniziaRilevazione.vue?vue&type=style&index=0&id=f616251a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f616251a"]])

export default __exports__